module.exports = __webpack_public_path__ + "static/media/competition.ae608f44.png";